<template>
  <nav class="tiger-nav flex-row">
    <div>
      <router-link to="/works">
        <div id="nav-title" class="flex-row">
          <svg-icon iconClass="footer-tiger-logo" className="nav-tiger-logo"></svg-icon>
          <p :style="{fontSize: myFontSize, marginLeft: myFontSize}" class="cn-24">潘虎设计实验室</p>
        </div>
      </router-link>
    </div>
    <div class="nav-menu flex-row">
      <router-link to="/works" active-class="nav-menu-active">
        <p :style="{fontSize: myFontSize}" class="cn-24-thin">作品透视</p>
      </router-link>
      <div :style="{fontSize: myFontSize}" class="cn-24 nav-separator">|</div>
      <router-link to="/about" active-class="nav-menu-active">
        <p :style="{fontSize: myFontSize}" class="cn-24-thin">关于我们</p>
      </router-link>
      <div :style="{fontSize: myFontSize}" class="cn-24 nav-separator">|</div>
      <router-link to="/contact" active-class="nav-menu-active">
        <p :style="{fontSize: myFontSize}" class="cn-24-thin">取得联系</p>
      </router-link>
    </div>
  </nav>
</template>

<script>
import {resize} from "@/utils/resize";

export default {
  name: "TigerNav",

  mixins: [resize],

  computed: {
    myFontSize() {
      return this.calcToPx(.25, 48, 96);
    }
  }
}
</script>

<style lang="scss" scoped>

.tiger-nav {
  width: 100%;
  min-width: 960px;
  height: .8333rem;
  max-height: 80px;
  justify-content: space-between;
  align-items: center;
  padding: 0 .625rem;
  background-color: rgba(29, 29, 31, .85);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);

  #nav-title {
    justify-content: center;
    align-items: center;
  }

  .nav-tiger-logo {
    height: .37rem;
    max-height: 36px;
    min-height: 12px;
    width: .37rem;
    max-width: 36px;
    min-width: 12px;
  }

  .nav-menu {
    justify-content: center;
    align-items: center;

    .nav-separator {
      color: $col-nav-separator;
      margin: 0 20px;
      cursor: default;
    }

    p {
      color: $col-nav-menu;

      &:hover {
        font-weight: 400;
        color: $col-primary-white;
      }
    }

    .nav-menu-active {
      p {
        font-weight: 400;
        color: $col-primary-white;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/TigerNav.vue